import { getUserPreferences } from '../../v2';

/**
 * * v3: Update for check mark properties - selectAll, toExport
 * * The structure is changed according to the current version v3.
 */
export default (params) => {
  const { nodeType, fieldType, fieldData } = params;
  let {
    document: { nodes: documentNodes },
  } = fieldData;

  const filteredSkills = documentNodes.filter((_, index) => index % 2 === 0);

  const { length: noOfSkills } = filteredSkills;
  if (noOfSkills > 0) {
    let selectAll = 0;
    let rolesCount = 0;

    /**
     * Iterate through each skill and find the ones which are ready to get exported.
     * Increase the count of 'selectAll' for every exportable skill
     */
    filteredSkills.forEach((skill) => {
      const mutateSkill = skill;
      const { data: skillData } = skill;
      const { toExport: isExported } = skillData;
      mutateSkill.type = 'skill_title';
      delete skillData.collapse;
      if (isExported) {
        selectAll += 1;
        rolesCount += 1;
      }
    });

    /**
     * Update skills object
     */
    documentNodes = [
      {
        object: 'block',
        type: `skill_organization_details`,
        nodes: [
          {
            object: 'block',
            type: `skill_organization_name`,
            nodes: [
              {
                object: 'text',
                leaves: [
                  {
                    text: '',
                  },
                ],
              },
            ],
          },
        ],
      },
      ...documentNodes,
    ];

    documentNodes = [
      {
        object: 'block',
        type: `skill_organization`,
        data: {
          selectAll,
        },
        nodes: documentNodes,
      },
      {
        object: 'block',
        type: 'empty_paragraph',
        nodes: [
          {
            object: 'text',
            leaves: [
              {
                text: ' ',
              },
            ],
          },
        ],
      },
    ];

    const skills = {
      ...fieldData,
      document: {
        ...fieldData.document,
        data: {
          ...fieldData.document.data,
          version: {
            number: 3,
            updated: true,
          },
          selectAll: selectAll === filteredSkills.length ? 1 : 0,
          rolesCount,
        },
        nodes: documentNodes,
      },
    };

    /**
     * Update user preferences too, as toExport of left pane depends on the selectAll count
     * Note: Sometimes, in the corrupted data, properties might be missing, so this can be corrected with version management
     */
    let { userPreferences } = params;

    userPreferences = getUserPreferences({
      fieldType,
      nodeType,
      fieldValue: selectAll > 0,
      userPreferences,
    });

    return { skills, userPreferences };
  }

  return null;
};
